export default "__VITE_ASSET__C_k9SRat__"